// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"381":"2f5854c2","453":"861978f7","721":"c7643573"}[chunkId] + ".chunk.js");